var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "remarks_class" },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            "default-sort": { prop: "createTime" },
          },
          on: { "sort-change": _vm.handleSortChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "createTime",
              sortable: "custom",
              label: _vm.$t("userManage.time"),
              align: "center",
              width: "180",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "createUserName",
              label: _vm.$t("collectionCenter.controlsEmployee"),
              align: "center",
              width: "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "siteName",
              label: _vm.$t("collectionCenter.belongSite"),
              align: "center",
              width: "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "operationType",
              label: _vm.$t("collectionCenter.operation"),
              align: "center",
              width: "90",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "remark",
              label: _vm.$t("collectionCenter.detail"),
              align: "center",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }